export default __webpack_public_path__ + "static/media/golf.cafe0ed3.png";